import { HubConnectionBuilder } from '@microsoft/signalr';
import enviroments from '../../enviroments';

const getConnectionHubAgendamento = () => getNewHubConnectionBuilder('/agendamento');

const getConnectionHubAdmin = () => getNewHubConnectionBuilder('/admin');

const getNewHubConnectionBuilder = (hub: string) => {
  const toJson = localStorage.getItem('@token');
  const dataUser = toJson == null ? null : JSON.parse(toJson);

  return new HubConnectionBuilder()
    .withUrl(`${enviroments.API_URL_SOCKET}/hubs${hub}`, {
      accessTokenFactory: () => dataUser.token,
    })
    .withAutomaticReconnect()
    .build();
};

export const hubsSocket = {
  getConnectionHubAgendamento,
  getConnectionHubAdmin,
};
